<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">File Name:</label>
        <div class="col-sm-9">
          <p class="form-control-plaintext text-small">{{ fileName }}</p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Upload Type:</label>
        <div class="col-sm-9">
          <select class="form-control" name="file_type" v-model="data.fileType">
            <option v-for="ft in fileTypes" :value="ft['id']">{{ ft['value'] }}</option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Description:</label>
        <div class="col-sm-9">
          <textarea class="form-control" name="description" placeholder="Enter file description..." rows="2" :value="data.fileDescription"></textarea>
        </div>
      </div>

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">Cancel</button>
      <button type="submit" class="btn btn-primary" :form="formId"><i class="fa fa-fw fa-save"></i> Save</button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {

  /**
   *
   * Modal form allows to update type and description of claim upload.
   *
   * Input properties:
   *
   * modalId   - custom id for modal component.
   * action    - form action URL.
   * title     - form title.
   * fileTypes - list of file types.
   *
   *
   * Usage examples:
   *
   * <edit-file-upload-modal
   *                 title="Update File Upload"
   *                 action="{{ route('uploads.update', ['claim' => $claim, 'file' => $upload]) }}"
   *                 file-name="{{ $upload->name }}"
   *                 file-type="{{ $upload->type }}"
   *                 file-description="{{ $upload->description }}"
   *                 :file-types="{{$file_types}}">
   *   <a class="btn btn-sm btn-white" v-modal="'editFileModal'">
   *     <i class="fa fa-pencil-square"></i> Edit
   *   </a>
   * </edit-file-upload-modal>
   *
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id
    modalId: {
      required: false,
      type: String,
      default: 'editFileModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

    fileType: {
      type: String,
      default: ""
    },

    fileName: {
      type: String,
      default: ""
    },

    fileDescription: {
      type: String,
      default: ""
    },

    // File types list.
    fileTypes: {
      type: Array,
      default: () => {return [];}
    },

  },

  /**
   * Variables (models).
   */
  data() {
    return {
      data: {
        fileType: this.fileType,
        fileDescription: this.fileDescription,
      }
    }
  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    }

  }
}
</script>
